export default __webpack_public_path__ + "static/media/40-min.645397d1.jpg";